import axios from "axios";
import { api } from "./VaultApi";
import { toast } from "react-toastify";
import { ADMIN_ACTIVITY_LOG } from "../../Store/Type";

const apiUrl = process.env.REACT_APP_API_URL

export const GetAdminLogs = async({dispatch,typeFilter,page,limit}) => {
    const url1 = `${apiUrl}/v1/audit/log/1?page=${page}&limit=${limit}`
    const url2 = `${apiUrl}/v1/audit/log/2?page=${page}&limit=${limit}`    
    try{
        const response = await api.get(typeFilter === "activity_logs" ? url1 : url2)
        dispatch({
              type: ADMIN_ACTIVITY_LOG,
              payload: response?.data?.data || [],
              pageContext: response?.data?.pagination || {},
            });
        return response?.data
    } catch (error) {
        console.error("failed to get logs",error)
    }
}